import React, { useState } from 'react';
import './ShareModal.css';

function ShareModal({ isOpen, onClose, galleryImage, gallerySlug, isCapturingScreenshot }) {
    const [copied, setCopied] = useState(false);
    const [copiedView, setCopiedView] = useState(false);

    if (!isOpen) return null;

    const baseUrl = window.location.origin + window.location.pathname;
    const currentUrl = new URL(window.location.href);
    
    // Create gallery URL, preserving existing params but overriding gallery param
    const galleryUrl = new URL(baseUrl);
    galleryUrl.searchParams.set('gallery', gallerySlug);
    
    // Create view URL with gallery and view params
    const viewUrl = new URL(baseUrl);
    viewUrl.searchParams.set('gallery', gallerySlug);
    viewUrl.searchParams.set('view', 'true');
    
    const galleryUrlString = galleryUrl.toString();
    const viewUrlString = viewUrl.toString();

    const handleCopy = async (url, isViewUrl = false) => {
        try {
            await navigator.clipboard.writeText(url);
            if (isViewUrl) {
                setCopiedView(true);
                setTimeout(() => setCopiedView(false), 2000);
            } else {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            }
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = galleryImage;
        link.download = 'gallery-screenshot.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="share-modal-overlay">
            <div className="share-modal-content">
                <button className="modal-close-button" onClick={onClose}>×</button>
                <h2>Share Gallery</h2>
                
                <div className="share-section">
                    <h3>Gallery Screenshot</h3>
                    {isCapturingScreenshot ? (
                        <div className="screenshot-preview">
                            <div className="loading-screenshot">
                                <div className="loading-spinner"></div>
                                <p>Capturing screenshot...</p>
                            </div>
                        </div>
                    ) : galleryImage ? (
                        <div className="screenshot-preview">
                            <img src={galleryImage} alt="Gallery screenshot" />
                            <button onClick={handleDownload}>Download</button>
                        </div>
                    ) : (
                        <div className="screenshot-preview">
                            <p>No screenshot available</p>
                        </div>
                    )}
                </div>

                <div className="share-section">
                    <h3>Gallery Links</h3>
                    <div className="link-row">
                        <input type="text" value={galleryUrlString} readOnly />
                        <button onClick={() => handleCopy(galleryUrlString)}>
                            {copied ? 'Copied!' : 'Copy'}
                        </button>
                    </div>
                    <div className="link-row">
                        <input type="text" value={viewUrlString} readOnly />
                        <button onClick={() => handleCopy(viewUrlString, true)}>
                            {copiedView ? 'Copied!' : 'Copy View Link'}
                        </button>
                    </div>
                    <p className="link-info">
                        Share the view link to let others explore your gallery without editing permissions.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ShareModal; 